import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AlertNotificationPanel = ({ alerts, onPackageSelect, packages }) => {
  if (!alerts || alerts?.length === 0) return null;

  const getAlertConfig = (type) => {
    const configs = {
      error: { bgColor: 'bg-error/10', borderColor: 'border-error/30', textColor: 'text-error', icon: 'AlertCircle' },
      warning: { bgColor: 'bg-warning/10', borderColor: 'border-warning/30', textColor: 'text-warning', icon: 'AlertTriangle' },
      info: { bgColor: 'bg-primary/10', borderColor: 'border-primary/30', textColor: 'text-primary', icon: 'Info' }
    };
    return configs?.[type] || configs?.info;
  };

  const formatTime = (timestamp) => {
    const now = new Date();
    const diff = Math.floor((now - timestamp) / 1000);
    
    if (diff < 60) return 'À l\'instant';
    if (diff < 3600) return `Il y a ${Math.floor(diff / 60)} min`;
    if (diff < 86400) return `Il y a ${Math.floor(diff / 3600)} h`;
    return `Il y a ${Math.floor(diff / 86400)} j`;
  };

  const handleAlertClick = (alert) => {
    const pkg = packages?.find(p => p?.packageNumber === alert?.packageNumber);
    if (pkg) {
      onPackageSelect(pkg);
    }
  };

  return (
    <div className="mb-6 space-y-3">
      {alerts?.map(alert => {
        const config = getAlertConfig(alert?.type);
        return (
          <div
            key={alert?.id}
            className={`${config?.bgColor} border ${config?.borderColor} rounded-lg p-4 cursor-pointer hover:shadow-md transition-shadow`}
            onClick={() => handleAlertClick(alert)}
          >
            <div className="flex items-start gap-3">
              <Icon name={config?.icon} size={20} className={config?.textColor} />
              <div className="flex-1">
                <div className="flex items-start justify-between mb-1">
                  <h4 className={`text-sm font-semibold ${config?.textColor}`}>{alert?.title}</h4>
                  <span className="text-xs text-gray-600">{formatTime(alert?.timestamp)}</span>
                </div>
                <p className="text-sm text-gray-900 mb-2">{alert?.message}</p>
                <div className="flex items-center gap-3">
                  <span className="text-xs font-medium text-gray-700">Colis: {alert?.packageNumber}</span>
                  <Button variant="ghost" size="sm" iconName="ArrowRight">
                    Voir les détails
                  </Button>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AlertNotificationPanel;